import { Button, ButtonProps, Typography, styled } from "@mui/material";
import { useState } from "react";
import VisibilityIcon from "@mui/icons-material/Visibility";
import LogoutIcon from "@mui/icons-material/Logout";

// Float on the right middle
const ContainerButton = styled(Button)(({ theme }) => ({
	backgroundColor: theme.palette.success.main,
	width: 200,
	color: "#fff",
	"&:hover": {
		backgroundColor: theme.palette.legacySecondary["400"],
	},
}));

export function TestModeButton({ children, useRemUnit, ...props }: ButtonProps & { useRemUnit?: boolean }) {
	const [isHovering, setIsHovering] = useState(false);
	return (
		<ContainerButton
			onMouseOver={() => setIsHovering(true)}
			onMouseLeave={() => setIsHovering(false)}
			startIcon={isHovering ? <LogoutIcon /> : <VisibilityIcon />}
			{...props}
		>
			<Typography component="span" fontWeight={600} fontSize={useRemUnit ? "1.6rem" : "16px"} color="inherit">
				{/* TODO: #loc */}
				{isHovering ? "Exit Mode" : "Test Mode"}
			</Typography>
		</ContainerButton>
	);
}
